import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const HikingIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"hiking"} ref={ref}/>
});

HikingIcon.displayName = "HikingIcon";
